import React from 'react';
import PropTypes from 'prop-types';
import { Digits, Title } from '../../common';

export default function NewPassword({ onChange, values, forceFocus, color }) {
  return (
    <>
      <Title marginBottom="44px">Digite sua nova senha</Title>
      <Digits
        forceFocus={forceFocus}
        type="password"
        label="Informe apenas 4 dígitos"
        onChange={objValue => onChange(objValue, 'new_password')}
        values={values}
        color={color}
      />
    </>
  );
}

NewPassword.propTypes = {
  onChange: PropTypes.func.isRequired,
  values: PropTypes.object,
  forceFocus: PropTypes.string,
};
